const controller = '/demo'
export default axios => ({
  postDemo(obj) {
    return axios.post(`${controller}`, obj)
  },
})